<button type="button" mat-flat-button [disabled]="inProgress" color="primary">
    <div class="d-flex justify-content-center align-items-center gap-4">
        <mat-spinner [diameter]="20" *ngIf="inProgress"></mat-spinner>
        <span>{{ inProgress ? inProgressText : idleText }}</span>
    </div>
</button>
